import React from "react";
import R14, { StyleSheet, Form, Text, View, ScrollView, Platform } from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import PamMessasgeBottomSection from "../components/PamMessasgeBottomSection";
import CommonValidators from "../utils/CommonValidators";
import CommonUtility from "../utils/CommonUtility";
import { BILLER_STATUS } from "../constant/app.data.constant";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import PAMPerferencesComponent from "../components/PAMPerferencesComponent";
import { CommonString } from "../constant/appCommonText";
import DateUtils from "../utils/DateUtils";
import ChatboxInputField from "../components/ChatboxInputField";

const defaultSec = 60; // default 10 seconds

export default R14.connect(
  class PamMessageScreen extends React.Component {
    constructor(props) {
      super(props);
      this.scrollRef = React.createRef();
      const { moreInfo } = this.props;
      const chat = [];
      if (moreInfo && moreInfo.moreInfos) {
        const { moreInfos } = moreInfo;
        moreInfos.forEach((ele) => {
          if (ele.moreInfoMessage) chat.push({ payer: ele.moreInfoMessage, updated: ele.updated });
          if (ele.moreInfoReply) chat.push({ biller: ele.moreInfoReply, updated: ele.updated });
        });
      }

      this.state = {
        messageContentHeight: 0,
        scrollCount: 0,
        chatMessage: chat,
        biller: props.pam.biller,
        isChatAllow: true, // this.props.messageFlag,
        isPreferencePopup: false,
        isEmailNotification: props.pam.textToPayPreference && (props.pam.textToPayPreference === "SMS" || props.pam.textToPayPreference === "None") ? false : true,
        isSMSNotification: props.pam.textToPayPreference && (props.pam.textToPayPreference === "Email" || props.pam.textToPayPreference === "None") ? false : true
      };

      this.timerInstance = null;
    }

    async componentDidMount() {
      this.form = this.props.app.ui.form("chatBox");
      const { pam, moreInfo } = this.props;
      if (moreInfo && moreInfo.status === "requested") {
        const moreInfoReply = moreInfo && moreInfo.moreInfos ? moreInfo.moreInfos.filter((el) => !!el.moreInfoReply).length + 1 : 1;
        await this.props.app.dm.billerDirectoryDomain.updatePamMessages({ readMessages: moreInfoReply, uid: pam.uid });
      }
      this.timerInstance = setInterval(async () => {
        this.updatePam();
      }, 1000 * defaultSec);
    }

    updatePam = async () => {
      const { pam } = this.props;
      const { pamList } = this.props.app.dm.billerDirectoryDomain.state;
      const { biller } = this.state;

      const pamRes = await this.props.app.dm.billerDirectoryDomain.moreInfoMessages(pam.pamId, pam.payerId, true); // api call....
      if (!!pamRes && !!pamRes.moreInfos && !!pamRes.moreInfos.length && pamRes.status === "requested") {
        const { moreInfos } = pamRes;
        const moreInfoReply = moreInfos.filter((el) => !!el.moreInfoReply);

        if (!!pamList.length) {
          let ind = pamList.findIndex((el) => el.uid === pam.uid);
          pamList[ind].readMessages = moreInfoReply.length;
          this.props.app.dm.billerDirectoryDomain.setState({ pamList });
        }
        if (moreInfos) {
          const chat = [];
          moreInfos.forEach((ele) => {
            if (ele.moreInfoMessage) chat.push({ payer: ele.moreInfoMessage, updated: ele.updated });
            if (ele.moreInfoReply) chat.push({ biller: ele.moreInfoReply, updated: ele.updated });
          });
          this.setState({
            chatMessage: chat,
            biller: biller,
          });
        }
      }
    };

    componentWillUnmount() {
      if (this.timerInstance) {
        clearInterval(this.timerInstance);
      }
    }

    onSubmit = async (form) => {
      const { chatMessage, messageContentHeight, biller } = this.state;
      const { enterMessage } = form.values;
      if (enterMessage && enterMessage.length > 140) {
        form.elmts.enterMessage.setError(CommonString.ContentExceed140);
        return false;
      }
      let res = await this.props.app.dm.billerDirectoryDomain.createPamMesagePayload(
        form.values.enterMessage,
        this.props.pam.pamId,
        this.props.pam.payerId
      );
      form.reset();
      if (!!res && !!res.mimId) {
        this.setState({
          chatMessage: chatMessage.concat({ payer: res.moreInfoMessage, updated: res.updated || new Date() }),
          biller: biller,
        });
        this.scrollToEnd({ y: messageContentHeight });
        return true;
      }
      else {
        this.props.app.dm.commonDomain.showToastr("error", CommonString.SomethingWentWrong);
      }
      return false;
    };

    layoutChange = (event) => {
      let evtobj = event.nativeEvent.layout;
      this.setState({
        messageContentHeight: evtobj.height,
      });

      this.scrollToEnd({ y: evtobj.height });
    };

    scrollToEnd(options = { animated: true }) {
      if (this.scrollRef.current) {
        this.scrollRef.current.scrollToEnd(options);
      }
    }

    readText = (val) => {
      if ((!val && !!this.form) || val.length <= 140) {
        this.form.elmts.enterMessage.setError(null);
      } else if (val.length > 140) {
        this.form.elmts.enterMessage.setError(CommonString.ContentExceed140);
      }
    };

    handleCloseModel = () => {
      this.setState({
        isPreferencePopup: false
      })
    };

    reSyncBiller = async () => {
      return false;
    }

    renderModelPopup(isPreferencePopup) {
      return (
        <PAMPerferencesComponent
          pam={this.props.pam}
          biller={this.state.biller}
          handleCloseModel={this.handleCloseModel}
          visibility={!!isPreferencePopup}
          reSyncBiller={this.reSyncBiller}
          moreInfo={this.props.moreInfo}
          isBlocked={this.props.pam.status === "blocked"}
          emailStatus={this.state.isEmailNotification}
          SMSstatus={this.state.isSMSNotification}
        />
      )
    }

    render() {
      const { pam, moreInfo } = this.props;
      const { chatMessage, biller, isChatAllow } = this.state;
      let additionalUserInfo = this.props.userDetails;
      if (additionalUserInfo && additionalUserInfo.length) additionalUserInfo = additionalUserInfo[0];
      let userShortName = additionalUserInfo.firstName + (additionalUserInfo.lastName ? " " + additionalUserInfo.lastName : "");
      return (
        <>
            {this.renderModelPopup(this.state.isPreferencePopup)}
            <View style={[styles.pamMessageScreen, commonStyles.flex1, commonStyles.pageBorderRadius5,]}>
                <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, styles.cardBox]}>
                  <View style={[styles.userIconDiv, commonStyles.dFlex, commonStyles.alignItemsCenter, commonStyles.justifyContentCenter]}>
                    <Text style={[commonStyles.heading6, commonStyles.fontWeight600, commonStyles.userInitial, commonFontStyles.workSans]}>
                      {CommonUtility.shortName(biller.billerName)}
                    </Text>
                  </View>
                  <View style={[commonStyles.flex1, commonStyles.customFlexDirection, styles.infoAndStatus]}>
                    <View style={[customCommonStyles.customCardRightDiv]}>
                      <View style={[commonStyles.flex1, commonStyles.customFlexDirection]}>
                        <View>
                          <Text
                            style={[
                              styles.cardHeadingText,
                              commonStyles.heading5,
                              commonStyles.fontWeight500,
                              commonFontStyles.workSans,
                              commonStyles.wordBreakWord,
                            ]}>
                            {biller.billerName}
                          </Text>
                        </View>
                      </View>
                      <View style={[styles.statusAndPreference, commonStyles.flex1, commonStyles.alignItemsFlexEnd, commonStyles.displayNone]}>
                        <View style={[commonStyles.flex1, commonStyles.customFlexDirection]}>
                          <Text
                            style={[
                              styles.cardSubHeadingText,
                              commonStyles.heading6,
                              commonStyles.fontWeight600,
                              commonFontStyles.workSans,
                              commonStyles.margin0,
                            ]}>
                            Business unit:{" "}
                          </Text>
                          <Text
                            style={[
                              styles.cardSubHeadingText,
                              commonStyles.heading6,
                              commonFontStyles.workSans,
                              commonStyles.margin0,
                            ]}>
                            {!!biller.buName ? biller.buName : biller.buId}
                          </Text>
                        </View>
                      </View>
                      <View style={[commonStyles.flex1, commonStyles.customFlexDirection]}>
                        <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
                          <Text
                            style={[
                              styles.cardSubHeadingText,
                              commonStyles.heading6,
                              commonStyles.fontWeight600,
                              commonFontStyles.workSans,
                              commonStyles.margin0,
                            ]}>
                            Request Type:{" "}
                          </Text>
                          <Text style={[styles.cardSubHeadingText, commonStyles.heading6, commonFontStyles.workSans, commonStyles.margin0]}>
                            Pre Authorization Request
                          </Text>
                        </View>
                        <View style={[commonStyles.flex1, commonStyles.customFlexDirection, commonStyles.justifyContentSpaceBetween]}>
                          <View style={[styles.statusSection, commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.flexGrow0, styles.customJustifyContentFlexEnd]}>
                            <Text
                              style={[
                                styles.cardSubHeadingText,
                                commonStyles.heading6,
                                commonStyles.fontWeight600,
                                commonFontStyles.workSans,
                                commonStyles.margin0,
                              ]}>
                              Status:{" "}
                            </Text>
                            <View style={[styles.statusCircle, styles.blocked, styles[`${BILLER_STATUS[moreInfo.status] ? BILLER_STATUS[moreInfo.status].toLowerCase(): BILLER_STATUS[moreInfo.status]}`], ]}></View>
                            <Text
                              style={[
                                styles.cardSubHeadingText, 
                                commonStyles.heading6,
                                commonFontStyles.workSans,
                                commonStyles.margin0,
                                commonStyles.transformUpperCase,
                              ]}>
                              {BILLER_STATUS[moreInfo.status]}
                            </Text>
                          </View>
                      </View>
                  </View>
                  </View>
                </View>
              </View>
              <ScrollView
                key={this.state.scrollCount}
                ref={this.scrollRef}
                onLayout={this.layoutChange}
                height={Platform.OS !== "web" ? null : this.state.messageContentHeight}
                style={[styles.centerScrollable, customCommonStyles.customPamMessageCenterScrollable,
                !["accepted", "denied", "blocked", "payerblocked"].includes(moreInfo.status) ?
                  customCommonStyles.pamMessageWithPreference : customCommonStyles.pamMessageCenterScrollableWithoutBottom,
                ]}>
                <View style={[commonStyles.flex1, commonStyles.padding5]}>
                  <View style={[commonStyles.textAlignCenter, commonStyles.marginBottom10]}>
                    <Text
                      style={[
                        commonStyles.exSmallHeading,
                        commonStyles.chatTiming,
                        commonStyles.marLAuto,
                        commonFontStyles.workSans,
                      ]}></Text>
                  </View>
                  <View style={[styles.chatBoxWidth]}>
                    <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, styles.userInitialDiv]}>
                      <View style={[commonStyles.userInitialOuter, styles.billerInitial]}>
                        <Text style={[commonFontStyles.workSans, commonStyles.fileSize, commonStyles.fontWeight500]}>
                          {CommonUtility.shortName(biller.billerName)}
                        </Text>
                      </View>
                      <View>
                        <Text style={[commonStyles.guestName, commonFontStyles.workSans]}>{biller.billerName}</Text>
                      </View>
                    </View>
                    <View>
                      <View style={[commonStyles.minWidth150, commonStyles.guestText, commonStyles.dInlineFlex, commonStyles.flexDirectionColumn]}>
                        <View>
                          <Text style={[commonStyles.smallHeading, commonStyles.fontWeight500, commonFontStyles.workSans]}>
                            Request For Authorisation
                          </Text>
                        </View>
                        <View>
                          {moreInfo ? <Text style={[commonStyles.smallHeading, commonFontStyles.workSans]}>{moreInfo.requestMessage}</Text> : null}
                        </View>
                        <View style={[commonStyles.guestTextBorder]}></View>
                      </View>
                    </View>
                    <View style={commonStyles.marLAuto}>
                      <Text
                        style={[
                          commonStyles.exSmallHeading,
                          commonStyles.chatTiming,
                          commonStyles.transperentBtnColor,
                          commonStyles.marLAuto,
                          commonFontStyles.workSans,
                        ]}></Text>
                    </View>
                  </View>
                  <View>
                    {chatMessage.map((item, indx) => (
                      <View key={indx}>
                        {item.payer ? (
                          <View style={[commonStyles.marginBottom15, commonStyles.dFlex, commonStyles.flexDirectionColumn]}>
                            <View style={[commonStyles.minWidth150, commonStyles.marLAuto]}>
                              <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
                                <View style={[styles.userInitialOuter, styles.payerInital]}>
                                  <Text
                                    style={[
                                      commonFontStyles.workSans,
                                      commonStyles.fileSize,
                                      commonStyles.blackTextColor,
                                      commonStyles.fontWeight500,
                                    ]}>
                                    {CommonUtility.shortName(userShortName)}
                                  </Text>
                                </View>
                                <View>
                                  <Text
                                    style={[
                                      commonStyles.guestName,
                                      commonFontStyles.workSans,
                                      commonStyles.blackTextColor,
                                    ]}>
                                    {userShortName}
                                  </Text>
                                </View>
                              </View>
                              <View style={[styles.responceMsg, commonStyles.hostText]}>
                                <Text style={[commonStyles.smallHeading, commonFontStyles.workSans]}>{item.payer}</Text>
                                <Text style={[commonStyles.hostTextBorder]}></Text>
                              </View>
                              <View style={[commonStyles.textAlignRight, item.updated ? null : commonStyles.displayNone]}>
                                <Text
                                  style={[
                                    commonStyles.exSmallHeading,
                                    commonStyles.marLAuto,
                                    commonFontStyles.workSans,
                                    commonStyles.textAlignRight
                                  ]}>
                                  {DateUtils.formatDateInMMDDYYYY(item.updated)}
                                </Text>
                              </View>
                            </View>
                          </View>
                        ) : (
                          <View style={[commonStyles.marginBottom15, styles.chatBoxWidth, commonStyles.dFlex, commonStyles.flexDirectionColumn]}>
                            <View style={[commonStyles.minWidth150, commonStyles.marRAuto]}>
                              <View style={[commonStyles.flex1, commonStyles.flexDirectionRow]}>
                                <View style={[styles.userInitialOuter, styles.billerInitial]}>
                                  <Text style={[commonFontStyles.workSans, commonStyles.fileSize, commonStyles.fontWeight500]}>
                                    {CommonUtility.shortName(pam.biller.billerName)}
                                  </Text>
                                </View>
                                <View>
                                  <Text style={[commonStyles.guestName, commonFontStyles.workSans]}>
                                    {pam.biller.billerName}
                                  </Text>
                                </View>
                              </View>
                              <View style={[styles.responceMsg, styles.billerText]}>
                                <Text style={[commonStyles.smallHeading, commonFontStyles.workSans]}>{item.biller}</Text>
                                <Text style={[styles.billerBorder]}></Text>
                              </View>

                              <View style={[commonStyles.textAlignRight, item.updated ? null : commonStyles.displayNone]}>
                                <Text
                                  style={[
                                    commonStyles.exSmallHeading,
                                    // commonStyles.chatTiming, 
                                    commonStyles.textAlignRight,
                                    commonFontStyles.workSans
                                  ]}>
                                  {DateUtils.formatDateInMMDDYYYY(item.updated)}
                                </Text>
                              </View>
                            </View>
                          </View>
                        )}
                        <View style={commonStyles.marLAuto}>
                          <Text
                            style={[
                              commonStyles.exSmallHeading,
                              commonStyles.chatTiming,
                              commonStyles.transperentBtnColor,
                              commonStyles.marLAuto,
                              commonFontStyles.workSans,
                            ]}></Text>
                        </View>
                      </View>
                    ))}
                  </View>
                </View>
              </ScrollView>
              {!["accepted", "denied", "blocked", "payerblocked"].includes(moreInfo.status) ? (
                <View style={[styles.bottomSectionOuter]}>
                  {isChatAllow ? (
                    <View style={[styles.chatInputField, commonStyles.marginBottom20]}>
                      <View style={[commonStyles.enterMessage, commonStyles.marTAuto]}>
                        <Form
                          name="chatBox"
                          style={[commonStyles.padding0]}
                          validators={CommonValidators.getFormValidator()}
                          validateBeforeSubmit={true}
                          onSubmit={this.onSubmit}>
                            <ChatboxInputField
                              onSend = {() => this.onSubmit(this.form)}
                              name="enterMessage"
                              label={`${CommonString.ChatInputLabel}*`}
                              validator="cmtsVali"
                              required={CommonString.MessageRequired}
                              multiline
                              onChangeText={this.readText}
                            />
                        </Form>
                      </View>
                    </View>
                  ) : null}
                  <PamMessasgeBottomSection
                    pam={this.props.pam}
                    emailStatus={this.state.isEmailNotification}
                    SMSstatus={this.state.isSMSNotification}
                  />
                </View>
              ) : null}
            </View>
        </>
      );
    }
  }
);

const styles = StyleSheet.create({
  pamMessageScreen: {
    backgroundColor: "#fff",
    paddingTop: 5,
    paddingRight: 15,
    paddingBottom: 0,
    paddingLeft: 15,
    marginTop: 0,
    marginRight: 16,
    marginBottom: 16,
    marginLeft: 16,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#e2e2e2",
    screen: ({ width }) => {
      if (width <= 991)
        return {
          marginTop: 0,
          marginRight: 0,
          marginLeft: 0,
          marginBottom: 16,
          borderColor: "#fff",
        };
    },
  },
  userIconDiv: {
    width: 32,
    minWidth: 32,
    height: 32,
    borderTopLeftRadius: 32,
    borderTopRightRadius: 32,
    borderBottomLeftRadius: 32,
    borderBottomRightRadius: 32,
    backgroundColor: "#e7e7e7",
    marginRight: 16,
  },
  cardBox: {
    paddingTop: 15,
    paddingRight: 0,
    paddingBottom: 15,
    paddingLeft: 0,
    marginTop: 0,
    marginBottom: 0,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: "rgb(218, 218, 218)",
    maxHeight: 80,
    screen: ({ width }) => {
      if (width <= 991)
        return {
          maxHeight: 100,
          minHeight: 80,
        };
    },
  },
  cardHeadingText: {
    display: "block",
    fontSize: 16,
  },
  cardSubHeadingText: {
    color: "#444444",
    display: "block",
    fontSize: 14,
    marginRight: 0,
    marginLeft: 0,
  },
  blueButton: {
    backgroundColor: "#37c2ef",
    color: "#333",
    height: 52,
    width: 75,
    border: 0,
  },
  bottomSectionOuter: {
    marginTop: "auto",
    marginRight: -15,
    marginBottom: 0,
    marginLeft: -15,
    backgroundColor: "#fff",
  },
  chatInputField: {
    paddingTop: 15,
    paddingRight: 15,
    paddingBottom: 0,
    paddingLeft: 15,
    border: 0,
  },
  decline: {
    height: 13,
    width: 15,
    marginTop: 0,
    marginRight: 5,
    marginBottom: 0,
    marginLeft: 5,
  },
  statusSection: {
    screen: ({ width }) => {
      if (width >= 992) {
        return {
          marginLeft: "auto",
          textAlign: "right",
          alignItems: "flex-end"
        };
      }
    },
  },
  chatBoxWidth: {
    maxWidth: "85%",
    marginBottom: 15,
    display: "inline-flex",
    flexDirection: "column",
  },
  responceMsg: {
    marginBottom: 3,
  },
  active: {
    borderColor: "#218666",
  },
  requested: {
    borderColor: "#800080",
  },
  new: {
    borderColor: "#1277d9",
  },
  inprogress: {
    borderColor: "#EE781E",
  },
  accepted: {
    borderColor: "#218666",
  },
  denied: {
    borderColor: "#B40220",
  },
  blocked: {
    borderColor: "#B40220",
  },
  fieldsHolder: {
    position: "relative",
    flexGrow: 1,
  },
  messageTextField: {
    position: "relative",
    zIndex: 1,
    paddingTop: 8,
    paddingBottom: 8,
    resize: "none",
    lineHeight: 12,
  },
  messageTextInput: {
    maxHeight: 48,
    flexBasis: "75%",
    marginBottom: 15
  },
  billerBorder: {
    height: 0,
    width: 0,
    position: "absolute",
    bottom: 0,
    left: -9,
    borderTop: "5px solid transparent",
    borderRight: "5px solid #ecf3fe",
    borderBottom: "5px solid transparent",
    borderLeft: "5px solid transparent",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  billerText: {
    display: "block",
    backgroundColor: "#ecf3fe",
    paddingTop: 5,
    paddingRight: 10,
    paddingBottom: 5,
    paddingLeft: 10,
    position: "relative",
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
    borderBottomLeftRadius: 3,
    borderBottomRightRadius: 2,
    marginTop: 2,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
  },
  userInitialOuter: {
    height: 20,
    width: 20,
    maxWidth: 20,
    borderTopLeftRadius: 100,
    borderTopRightRadius: 100,
    borderBottomLeftRadius: 100,
    borderBottomRightRadius: 100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  payerInital: {
    backgroundColor: "#e7e7e7",
  },
  billerInitial: {
    backgroundColor: "#e7e7e7",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    height: 20,
    width: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  centerScrollable: {
    paddingTop: 16,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
  },
  infoAndStatus: {
    screen: ({ width }) => {
      if (width >= 991) {
        return {
          justifyContent: "space-between",
        }
      }
    }
  },
  statusAndPreference: {
    screen: ({ width }) => {
      if (width <= 991) {
        return {
          flexDirection: "row",
          marginLeft: 0,
        }
      }
    }
  },
  customJustifyContentFlexEnd: {
    alignItems: "center",
    screen: ({ width }) => {
      if (width >= 991) {
        return {
          justifyContent: "flex-end"
        }
      }
    }
  },
  statusCircle: {
    borderWidth: 5,
    borderStyle: "solid",
    borderRadius: 15,
    maxWidth: 5,
    maxHeight: 5,
    marginRight: 7,
  }
});
